<script lang="ts">
    import CategoryBrick from '@amp/web-app-components/src/components/lockups/CategoryBrick/CategoryBrick.svelte';
    import ClickAction from '~/components/jet/action/ClickAction.svelte';

    export let item;

    $: clickAction = item.segue;
    $: artwork = item.artwork;
    $: title = item.title;
</script>

<div class="category-brick-container">
    <ClickAction action={clickAction}>
        <CategoryBrick {artwork} {title} isHdAspectRatio={true} />
    </ClickAction>
</div>

<style lang="scss">
    .category-brick-container {
        display: contents;

        :global(.is-hd-aspect-ratio .category-brick__title) {
            font: var(--title-2-emphasized);
        }
    }
</style>
